import React, { useMemo } from 'react';

import { getIn } from 'formik';
import { FormikValues } from 'formik/dist/types';

import AppChipSelector, {
  IAppChipSelector,
} from '../../app-chip-selector/AppChipSelector';

export interface IAppFormChipSelector
  extends Omit<
    IAppChipSelector,
    'values' | 'onChange' | 'error' | 'helperText'
  > {
  name: string;
  formik?: FormikValues;
  onChange?: (values: any[]) => void;
}

const AppFormChipSelector: React.FC<IAppFormChipSelector> = ({
  formik,
  name,
  onChange,
  ...props
}) => {
  const values = useMemo(() => {
    const v = getIn(formik?.values, name);
    return Array.isArray(v) ? v : [];
  }, [formik?.values, name]);

  const touched = getIn(formik?.touched, name);
  const fieldError = getIn(formik?.errors, name);
  const error = !!touched && !!fieldError;
  const helperText =
    touched && fieldError != null && fieldError !== ''
      ? String(fieldError)
      : undefined;

  return (
    <AppChipSelector
      {...props}
      values={values}
      error={error}
      helperText={helperText}
      onChange={(newValues) => {
        if (onChange) {
          onChange(newValues);
        } else {
          formik?.setFieldValue(name, newValues);
          formik?.setFieldTouched(name, true, false);
        }
      }}
    />
  );
};

export default AppFormChipSelector;
